import React from 'react';
import { createRoot } from 'react-dom/client';
import NewsGrid from './components/NewsGrid';

console.log('index.jsx loaded at:', new Date().toISOString());

function renderApp() {
  const rootElement = document.getElementById('vatican-news-rss-root');
  const blockElement = document.querySelector('.block-vatican-news-rss-block[data-items]');

  if (rootElement) {
    try {
      const items = JSON.parse(rootElement.dataset.items || '[]');
      console.log('Parsed RSS items from root:', items);
      if (Array.isArray(items)) {
        const root = createRoot(rootElement);
        root.render(<NewsGrid items={items} />);
        console.log('Successfully rendered NewsGrid from root');
      } else {
        console.error('Error: data-items is not an array');
        rootElement.innerHTML = '<p class="text-red-600">Error: Invalid RSS data format</p>';
      }
    } catch (error) {
      console.error('Error parsing data-items from root:', error);
      rootElement.innerHTML = '<p class="text-red-600">Error loading RSS feed</p>';
    }
  } else if (blockElement) {
    try {
      const items = JSON.parse(blockElement.dataset.items || '[]');
      console.log('Parsed RSS items from block:', items);
      if (Array.isArray(items)) {
        const rootDiv = document.createElement('div');
        rootDiv.id = 'vatican-news-rss-root';
        blockElement.appendChild(rootDiv);
        const root = createRoot(rootDiv);
        root.render(<NewsGrid items={items} />);
        console.log('Successfully rendered NewsGrid from block');
      } else {
        console.error('Error: data-items is not an array');
        blockElement.innerHTML = '<p class="text-red-600">Error: Invalid RSS data format</p>';
      }
    } catch (error) {
      console.error('Error parsing data-items from block:', error);
      blockElement.innerHTML = '<p class="text-red-600">Error loading RSS feed</p>';
    }
  } else {
    console.error('Root element not found. Starting MutationObserver.');
    const observer = new MutationObserver((mutations, obs) => {
      const root = document.getElementById('vatican-news-rss-root');
      const block = document.querySelector('.block-vatican-news-rss-block[data-items]');
      if (root || block) {
        console.log('Root or block element detected by MutationObserver');
        obs.disconnect();
        renderApp();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded at:', new Date().toISOString());
  renderApp();
});
